var SnapshotsOfTypeMetadata = /** @class */ (function () {
    function SnapshotsOfTypeMetadata(modelType, snapshots, level) {
        this.modelType = modelType;
        this.snapshots = snapshots;
        this.level = level;
    }
    return SnapshotsOfTypeMetadata;
}());
export default SnapshotsOfTypeMetadata;
//# sourceMappingURL=SnapshotsOfTypeMetadata.js.map